// extracted by mini-css-extract-plugin
export default {"filtersBox":"styles_filtersBox__CVPQv"};